import { useRecoilState } from "recoil";
import { hasSiteAtom, userInfoAtom } from "src/atoms";
import { useGetCashStatus } from "../api/pay/useGetCashStatus";
import { useGetMyServiceList } from "../api/product/useGetMyServiceList";
import { useEffect, useState } from "react";
import { useRouter } from "../useRouter";

// 현금결제 신청한 상태인지 파악 (상태에따라 페이지 이동)
export const useIsCashApply = () => {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { userCashStatusLoading, userCashStatus, userCashStatusRefetch } =
    useGetCashStatus({ onSuccess: () => { } });
  const { isMyServiceLoading, serviceList } = useGetMyServiceList({});
  const [isCashApply, setIsCashApply] = useState<boolean>(false);
  const [hasSite, setHasSite] = useRecoilState(hasSiteAtom);
  const { goConsole } = useRouter();
  useEffect(() => {
    if (userCashStatus && serviceList) {
      if (
        serviceList.length === 1 &&
        serviceList[0].serviceStatus === "REGIST"
      ) {
        //현금결제든 아니든 등록된 사이트
        if (hasSite) {
          setIsCashApply(false);
        } else {
          if (["WAIT", "APPLY"].includes(userCashStatus.status)) {
            setIsCashApply(true);
          } else setIsCashApply(false);
        }
      } else {
        if (["WAIT", "APPLY"].includes(userCashStatus.status)) {
          setIsCashApply(true);
        } else setIsCashApply(false);
      }
    } else if (userCashStatus) {
      if (["WAIT", "APPLY"].includes(userCashStatus.status)) {
        setIsCashApply(true);
      }
      else if (["DONE"].includes(userCashStatus.status)) {
        setIsCashApply(false);
        // goConsole();
      }
      else setIsCashApply(false);
    }
  }, [userCashStatus, serviceList]);

  return { isCashApply };
};
